import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import Chart from 'react-google-charts';
import axios from 'axios';

export default function SiteAnnualReport() {

    const VISITATION_BASE_URL = process.env.REACT_APP_VISITATION_BASE_URL;
    const VISITATION_GETALL = process.env.REACT_APP_VISITATION_SEARCH;

    const PERFORMANCE_BASE_URL = process.env.REACT_APP_PERFORMANCE_BASE_URL;
    const PERFORMANCE_SEARCH = process.env.REACT_APP_PERFORMANCE_SEARCH;

    const FISCAL_BASE_URL = process.env.REACT_APP_FISCAL_BASE_URL;
    const FISCAL_SEARCH = process.env.REACT_APP_FISCAL_SEARCH;
    const [visitationData, setVisitationData] = useState([]);
    const [performanceData, setPerformanceData] = useState([]);
    const [fiscalData, setFiscalData] = useState([]);

    const visitData = {
        siteName: "",
        year: "",
        month: "",
        status: "APPROVED"
    }
    const [show, setShow] = useState(false);
    const handleInputChange = (e) => {
        console.log(e.target.value);
        visitData.siteName = e.target.value;
        console.log(visitData);
        const visitationAPI = VISITATION_BASE_URL + VISITATION_GETALL;
        console.log('visitation api ' + visitationAPI)
        if (visitationAPI) {
            const fetchdata = async () => {
                try {
                    const response = await axios.post(visitationAPI, visitData)
                    setVisitationData(response.data);
                } catch (error) {
                    console.error(error)
                }
            };
            fetchdata();
        }

        const perfAPI = PERFORMANCE_BASE_URL + PERFORMANCE_SEARCH;
        console.log(perfAPI)
        if (perfAPI) {
            const fetchPerfData = async () => {
                try {
                    const response = await axios.post(perfAPI, visitData)
                    const data = response.data;
                    console.log(`perf data:${data}`);
                    setPerformanceData(data);
                } catch (error) {
                    console.error(error)
                }
            }
            fetchPerfData();
        }

        const fiscalAPI = FISCAL_BASE_URL + FISCAL_SEARCH;
        console.log(fiscalAPI)
        if (fiscalAPI) {
            const fetchFiscalData = async () => {
                try {
                    const response = await axios.post(fiscalAPI, visitData)
                    const data = response.data;
                    console.log(`Fiscal data:${data}`);
                    setFiscalData(data);
                } catch (error) {
                    console.error(error)
                }
            }
            fetchFiscalData();
        }

    };


    const getTotalVisitation = (visitationData) => {
        const totalYearValues = {};
        const siteFiscalData = {};
        const resultArray = [];

        visitationData.forEach(entry => {
            const { siteName, fiscalYear, visitation } = entry;
            const totalPaid = visitation.paid.totalPaid || 0;
            const totalUnpaid = visitation.unpaid.totalUnpaid || 0;

            if (!siteFiscalData[fiscalYear]) {
                siteFiscalData[fiscalYear] = { totalPaid: 0, totalUnpaid: 0 };
            }
            siteFiscalData[fiscalYear] = {
                totalPaid: siteFiscalData[fiscalYear].totalPaid + totalPaid,
                totalUnpaid: siteFiscalData[fiscalYear].totalUnpaid + totalUnpaid,
            };

        });

        console.log(siteFiscalData);

        const years = Object.keys(siteFiscalData).sort();
        console.log(years[0]);
        // check any records
        if (years[0]) {

            //Table Title
            const fyYears = years.map(entry => `FY${entry}/${entry % 100 + 1}`);
            resultArray.push(['Visitation', ...fyYears]);

            // records
            const dataTypes = Object.keys(siteFiscalData[years[0]]);

            dataTypes.forEach(type => {
                let tempType = '';
                if (type === 'totalPaid')
                    tempType = 'Paid Visitation'
                if (type === 'totalUnpaid')
                    tempType = 'Unpaid Visitation'

                const rowData = [tempType];
                years.forEach(year => {
                    console.log(`year:${year} && ${siteFiscalData[year][type]}`);
                    rowData.push(siteFiscalData[year][type]);
                });
                resultArray.push(rowData);
            })

            // Add a row for total values
            const totalRow = ['Total Visitation'];
            years.forEach(year => {
                let total = 0;
                dataTypes.forEach(type => {
                    total += siteFiscalData[year][type];
                });
                totalRow.push(total);
            });
            resultArray.push(totalRow);
        }
        return resultArray;
    }



    const calculatePercentageChange = (yearsData) => {
        const values = Object.values(yearsData);
        const len = values.length;
        if (len >= 2) {
            const percentageChange = ((values[len - 1] - values[len - 2]) / Math.abs(values[len - 2])) * 100;
            return parseFloat(isNaN(percentageChange) ? 0 : percentageChange.toFixed(2));
        }
        return 0;
    };

    const getTotalAdmissionRevenue = (visitationData) => {

        const totalYearValues = {};
        const siteFiscalData = {};
        const resultArray = [];

        visitationData.forEach(entry => {
            const { siteName, fiscalYear, revenue } = entry;
            const total = parseFloat(revenue.totalAdmissionsRevenue) || 0.00;
            const phmcShare = parseFloat(revenue.phmcAdmissionShare) || 0.00;
            const associateShare = parseFloat(revenue.associateAdmissionShare) || 0.00;

            if (!siteFiscalData[fiscalYear]) {
                siteFiscalData[fiscalYear] = { phmcShare: 0, associateShare: 0, total: 0 };
            }
            siteFiscalData[fiscalYear] = {
                phmcShare: siteFiscalData[fiscalYear].phmcShare + phmcShare,
                associateShare: siteFiscalData[fiscalYear].associateShare + associateShare,
                total: siteFiscalData[fiscalYear].total + total,
            };

        });

        console.log(siteFiscalData);

        const years = Object.keys(siteFiscalData).sort();
        console.log(years[0]);
        // check any records
        if (years[0]) {

            //Table Title
            const fyYears = years.map(entry => `FY${entry}/${entry % 100 + 1}`);
            resultArray.push(['Admission Revenue', ...fyYears]);

            // records
            const dataTypes = Object.keys(siteFiscalData[years[0]]);

            dataTypes.forEach(type => {
                let tempType = '';
                if (type === 'total')
                    tempType = 'Total Revenue'
                if (type === 'phmcShare')
                    tempType = 'PHMC Revenue Share'
                if (type === 'associateShare')
                    tempType = 'Associate Revenue Share'
                const rowData = [tempType];
                years.forEach(year => {
                    console.log(`year:${year} && ${siteFiscalData[year][type]}`);
                    rowData.push(siteFiscalData[year][type]);
                });
                resultArray.push(rowData);
            })

        }
        return resultArray;
    }

    const getAdmissionRevenue = (visitationData) => {
        const resultData = {};
        const totalYearValues = {};


        visitationData.forEach(entry => {
            const { siteName, fiscalYear, revenue } = entry;
            const total = parseFloat(revenue.totalAdmissionsRevenue) || 0.00;
            const phmcShare = parseFloat(revenue.phmcAdmissionShare) || 0.00;
            const associateShare = parseFloat(revenue.associateAdmissionShare) || 0.00;
            if (!resultData[siteName]) {
                resultData[siteName] = {};
            }
            if (!resultData[siteName][fiscalYear]) {
                resultData[siteName][fiscalYear] = { total: 0, phmcShare: 0, associateShare: 0 };
            }
            resultData[siteName][fiscalYear] = {
                total: resultData[siteName][fiscalYear].total + total,
                phmcShare: resultData[siteName][fiscalYear].phmcShare + phmcShare,
                associateShare: resultData[siteName][fiscalYear].associateShare + associateShare
            }
            totalYearValues[fiscalYear] = {
                total: (totalYearValues[fiscalYear] ? totalYearValues[fiscalYear].total || 0 : 0) + total,
                phmcShare: (totalYearValues[fiscalYear] ? totalYearValues[fiscalYear].phmcShare || 0 : 0) + phmcShare,
                associateShare: (totalYearValues[fiscalYear] ? totalYearValues[fiscalYear].associateShare || 0 : 0) + associateShare
            };

        });

        const sortedYears = Array.from(new Set(visitationData.map(entry => entry.fiscalYear))).sort();
        const ar = sortedYears.flatMap(fiscalYear => [`${fiscalYear} total`, `${fiscalYear} phmc`, `${fiscalYear} associate`]);

        const resultArray = [['SiteName',
            ...sortedYears.flatMap(fiscalYear => [`FY${fiscalYear}/${fiscalYear % 100 + 1} Total`, `FY${fiscalYear}/${fiscalYear % 100 + 1} PHMC Share`, `FY${fiscalYear}/${fiscalYear % 100 + 1} Associate Share`])

        ]
        ]; // Get unique years
        // Object.entries(resultData).forEach((sitename, yearsdata) => {
        //     console.log(`site:${sitename}, years:${yearsdata}`);
        //     Object.values(sortedYears).forEach(e => console.log(`value:${resultData[sitename][e]}`))
        // })
        Object.entries(resultData).forEach(([siteName, yearsData]) => {
            const rowData = [siteName,
                ...sortedYears.flatMap(entry => resultData[siteName][entry] ? [resultData[siteName][entry].total || 0, resultData[siteName][entry].phmcShare || 0, resultData[siteName][entry].associateShare || 0] : 0),
            ];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total',
            ...sortedYears.flatMap(fiscalYear => totalYearValues[fiscalYear] ? [totalYearValues[fiscalYear].total || 0, totalYearValues[fiscalYear].phmcShare || 0, totalYearValues[fiscalYear].associateShare || 0] : 0)
        ];
        resultArray.push(totalRow);
        return resultArray;
    }
    const getOutofStateVisitors = (visitationData) => {
        const siteFiscalData = {};
        const resultArray = [];

        visitationData.forEach(entry => {
            const { fiscalYear, visitation } = entry;
            const outOfState = parseInt(visitation.paid.outOfStateVisitors) || 0;
            siteFiscalData[fiscalYear] = (siteFiscalData[fiscalYear] || 0) + outOfState;
        });

        console.log(siteFiscalData);

        const years = Object.keys(siteFiscalData).sort();
        console.log(years[0]);
        // check any records
        if (years[0]) {

            //Table Title
            const fyYears = years.map(entry => `FY${entry}/${entry % 100 + 1}`);
            resultArray.push(['Visitors', ...fyYears]);

            const rowData = ['Out Of State'];
            years.forEach(year => {
                console.log(`year:${year} && ${siteFiscalData[year]}`);
                rowData.push(siteFiscalData[year]);
            });
            resultArray.push(rowData);
        }
        return resultArray;
    }
    const getTotalEventAttendance = (visitationData) => {
        const siteFiscalData = {};
        const resultArray = [];

        visitationData.forEach(entry => {
            const { fiscalYear, eventsAdmissions } = entry;
            const totalPaid = parseInt(eventsAdmissions.visitorsPaid) || 0;
            const totalUnpaid = parseInt(eventsAdmissions.visitorsUnPaid) || 0;

            if (!siteFiscalData[fiscalYear]) {
                siteFiscalData[fiscalYear] = { totalPaid: 0, totalUnpaid: 0 };
            }
            siteFiscalData[fiscalYear] = {
                totalPaid: siteFiscalData[fiscalYear].totalPaid + totalPaid,
                totalUnpaid: siteFiscalData[fiscalYear].totalUnpaid + totalUnpaid,
            };

        });

        console.log(siteFiscalData);

        const years = Object.keys(siteFiscalData).sort();
        console.log(years[0]);
        // check any records
        if (years[0]) {

            //Table Title
            const fyYears = years.map(entry => `FY${entry}/${entry % 100 + 1}`);
            resultArray.push(['Event Attendance', ...fyYears]);

            // records
            const dataTypes = Object.keys(siteFiscalData[years[0]]);

            dataTypes.forEach(type => {
                let tempType = '';
                if (type === 'totalPaid')
                    tempType = 'Event Paid Attendance'
                if (type === 'totalUnpaid')
                    tempType = 'Event Unpaid Attendance'

                const rowData = [tempType];
                years.forEach(year => {
                    console.log(`year:${year} && ${siteFiscalData[year][type]}`);
                    rowData.push(siteFiscalData[year][type]);
                });
                resultArray.push(rowData);
            })

            // Add a row for total values
            const totalRow = ['Total Attendance'];
            years.forEach(year => {
                let total = 0;
                dataTypes.forEach(type => {
                    total += siteFiscalData[year][type];
                });
                totalRow.push(total);
            });
            resultArray.push(totalRow);
        }
        return resultArray;
    }

    const getTotalEventRevenue = (visitationData) => {
        const siteFiscalData = {};
        const resultArray = [];

        visitationData.forEach(entry => {
            const { fiscalYear, eventsAdmissions } = entry;
            const totalRevenue = parseInt(eventsAdmissions.totalEventRevenue) || 0;
            siteFiscalData[fiscalYear] = (siteFiscalData[fiscalYear] || 0) + totalRevenue;
        });

        console.log(siteFiscalData);

        const years = Object.keys(siteFiscalData).sort();
        console.log(years[0]);
        // check any records
        if (years[0]) {

            //Table Title
            const fyYears = years.map(entry => `FY${entry}/${entry % 100 + 1}`);
            resultArray.push(['Event Attendance', ...fyYears]);

            const rowData = ['Total Revenue'];
            years.forEach(year => {
                console.log(`year:${year} && ${siteFiscalData[year]}`);
                rowData.push(siteFiscalData[year]);
            });
            resultArray.push(rowData);
        }
        return resultArray;
    }

    const getPerformanceMeasure = (performanceData) => {
        const siteFiscalData = {};
        const resultArray = [];
        if (performanceData.length > 0)
            performanceData.forEach(entry => {
                const { personnel, fiscalYear } = entry;
                if (entry) {
                    const noOfAssociateStaff = parseInt(personnel.noOfAssociateStaff) || 0;
                    const noOfPhmcStaff = parseInt(personnel.noOfAssociateStaff) || 0;
                    const noOfVolunteers = parseInt(personnel.noOfAssociateStaff) || 0;
                    if (fiscalYear) {
                        if (!siteFiscalData[fiscalYear]) {
                            siteFiscalData[fiscalYear] = { totalnoOfAssociateStaff: 0, totalnoOfPhmcStaff: 0, totalnoOfVolunteers: 0 };
                        }
                        siteFiscalData[fiscalYear] = {
                            totalnoOfAssociateStaff: siteFiscalData[fiscalYear].totalnoOfAssociateStaff + noOfAssociateStaff,
                            totalnoOfPhmcStaff: siteFiscalData[fiscalYear].totalnoOfPhmcStaff + noOfPhmcStaff,
                            totalnoOfVolunteers: siteFiscalData[fiscalYear].totalnoOfVolunteers + noOfVolunteers,
                        };
                    }
                }
            })
        console.log(siteFiscalData);

        const years = Object.keys(siteFiscalData).sort();
        console.log(`sorted years ${years}, measure year:  ${years[0]}`);
        // pull latest in the sorted year
        if (years[0]) {

            //Table Title
            const fyYears = years.map(entry => `FY${entry}/${entry % 100 + 1}`);
            resultArray.push(['Staffing', ...fyYears]);

            // records
            const dataTypes = Object.keys(siteFiscalData[years[0]]);

            dataTypes.forEach(type => {
                let tempType = '';
                if (type === 'totalnoOfAssociateStaff')
                    tempType = 'Associate Staffs'
                if (type === 'totalnoOfPhmcStaff')
                    tempType = 'PHMC Staffs'
                if (type === 'totalnoOfVolunteers')
                    tempType = 'Volunteers'
                const rowData = [tempType];
                years.forEach(year => {
                    console.log(`year:${year} && ${siteFiscalData[year][type]}`);
                    rowData.push(siteFiscalData[year][type]);
                });
                resultArray.push(rowData);
            })
        }
        return resultArray;
    }

    const getProgramOverview = (performanceData) => {
        const siteFiscalData = {};
        const resultArray = [];
        performanceData.forEach(entry => {
            const { performanceData, fiscalYear } = entry;

            if (performanceData) {
                performanceData.forEach(data => {
                    const { qualitative, quantitative, netRevenue } = data;
                    const targetAudience = quantitative.targetAudiences;
                    const virtualOrInPerson = quantitative.virtualOrInPerson;
                    const attendance = parseInt(quantitative.attendance) || 0;

                    if (fiscalYear) {
                        console.log(targetAudience + ':' + virtualOrInPerson);
                        if (!siteFiscalData[fiscalYear]) {
                            siteFiscalData[fiscalYear] = {};
                        }
                        if (!siteFiscalData[fiscalYear]['YouthInPerson']) {
                            siteFiscalData[fiscalYear]['YouthInPerson'] = { noOfPrograms: 0, noOfAttendees: 0 };
                        }
                        if (targetAudience === 'Youth' && virtualOrInPerson === 'InPerson') {
                            siteFiscalData[fiscalYear]['YouthInPerson'] = {
                                noOfPrograms: siteFiscalData[fiscalYear]['YouthInPerson'].noOfPrograms + 1,
                                noOfAttendees: siteFiscalData[fiscalYear]['YouthInPerson'].noOfAttendees + attendance
                            }
                        }
                        if (!siteFiscalData[fiscalYear]['YouthHybrid']) {
                            siteFiscalData[fiscalYear]['YouthHybrid'] = { noOfPrograms: 0, noOfAttendees: 0 };
                        }

                        if (targetAudience === 'Youth' && virtualOrInPerson === 'Hybrid') {
                            console.log(`record youth hybrid `);
                            console.log(attendance);
                            siteFiscalData[fiscalYear]['YouthHybrid'] = {
                                noOfPrograms: siteFiscalData[fiscalYear]['YouthHybrid'].noOfPrograms + 1,
                                noOfAttendees: siteFiscalData[fiscalYear]['YouthHybrid'].noOfAttendees + attendance
                            }
                        }
                        if (!siteFiscalData[fiscalYear]['YouthVirtual']) {
                            siteFiscalData[fiscalYear]['YouthVirtual'] = { noOfPrograms: 0, noOfAttendees: 0 };
                        }
                        if (targetAudience === 'Youth' && virtualOrInPerson === 'Virtual') {
                            siteFiscalData[fiscalYear]['YouthVirtual'] = {
                                noOfPrograms: siteFiscalData[fiscalYear]['YouthVirtual'].noOfPrograms + 1,
                                noOfAttendees: siteFiscalData[fiscalYear]['YouthVirtual'].noOfAttendees + attendance
                            }
                        }
                        if (!siteFiscalData[fiscalYear]['AdultInPerson']) {
                            siteFiscalData[fiscalYear]['AdultInPerson'] = { noOfPrograms: 0, noOfAttendees: 0 };
                        }
                        if (targetAudience === 'Adult' && virtualOrInPerson === 'InPerson') {
                            siteFiscalData[fiscalYear]['AdultInPerson'] = {
                                noOfPrograms: siteFiscalData[fiscalYear]['AdultInPerson'].noOfPrograms + 1,
                                noOfAttendees: siteFiscalData[fiscalYear]['AdultInPerson'].noOfAttendees + attendance
                            }
                        }
                        if (!siteFiscalData[fiscalYear]['AdultHybrid']) {
                            siteFiscalData[fiscalYear]['AdultHybrid'] = { noOfPrograms: 0, noOfAttendees: 0 };
                        }
                        if (targetAudience === 'Adult' && virtualOrInPerson === 'Hybrid') {
                            siteFiscalData[fiscalYear]['AdultHybrid'] = {
                                noOfPrograms: siteFiscalData[fiscalYear]['AdultHybrid'].noOfPrograms + 1,
                                noOfAttendees: siteFiscalData[fiscalYear]['AdultHybrid'].noOfAttendees + attendance
                            }
                        }
                        if (!siteFiscalData[fiscalYear]['AdultVirtual']) {
                            siteFiscalData[fiscalYear]['AdultVirtual'] = { noOfPrograms: 0, noOfAttendees: 0 };
                        }
                        if (targetAudience === 'Adult' && virtualOrInPerson === 'Virtual') {
                            siteFiscalData[fiscalYear]['AdultVirtual'] = {
                                noOfPrograms: siteFiscalData[fiscalYear]['AdultVirtual'].noOfPrograms + 1,
                                noOfAttendees: siteFiscalData[fiscalYear]['AdultVirtual'].noOfAttendees + attendance
                            }
                        }
                        if (!siteFiscalData[fiscalYear]['AllInPerson']) {
                            siteFiscalData[fiscalYear]['AllInPerson'] = { noOfPrograms: 0, noOfAttendees: 0 };
                        }
                        if (targetAudience === 'All Ages' && virtualOrInPerson === 'InPerson') {
                            siteFiscalData[fiscalYear]['AllInPerson'] = {
                                noOfPrograms: siteFiscalData[fiscalYear]['AllInPerson'].noOfPrograms + 1,
                                noOfAttendees: siteFiscalData[fiscalYear]['AllInPerson'].noOfAttendees + attendance
                            }
                        }
                        if (!siteFiscalData[fiscalYear]['AllHybrid']) {
                            siteFiscalData[fiscalYear]['AllHybrid'] = { noOfPrograms: 0, noOfAttendees: 0 };
                        }
                        if (targetAudience === 'All Ages' && virtualOrInPerson === 'Hybrid') {
                            siteFiscalData[fiscalYear]['AllHybrid'] = {
                                noOfPrograms: siteFiscalData[fiscalYear]['AllHybrid'].noOfPrograms + 1,
                                noOfAttendees: siteFiscalData[fiscalYear]['AllHybrid'].noOfAttendees + attendance
                            }
                        }
                        if (!siteFiscalData[fiscalYear]['AllVirtual']) {
                            siteFiscalData[fiscalYear]['AllVirtual'] = { noOfPrograms: 0, noOfAttendees: 0 };
                        }
                        if (targetAudience === 'All Ages' && virtualOrInPerson === 'Virtual') {
                            siteFiscalData[fiscalYear]['AllVirtual'] = {
                                noOfPrograms: siteFiscalData[fiscalYear]['AllVirtual'].noOfPrograms + 1,
                                noOfAttendees: siteFiscalData[fiscalYear]['AllVirtual'].noOfAttendees + attendance
                            }
                        }

                    }

                }) //inner performance data
            }
        })
        console.log(siteFiscalData);

        const years = Object.keys(siteFiscalData).sort();
        console.log(`sorted years ${years}, measure year:  ${years[0]}`);
        // pull latest in the sorted year
        if (years[0]) {

            //Table Title
            const fyYears = years.map(entry => `FY${entry}/${entry % 100 + 1}`);
            resultArray.push(['Programming Overview', `FY${years[0]}/${years[0] % 100 + 1} No. of Programs`, `FY${years[0]}/${years[0] % 100 + 1} No. of Attendees`]);

            // records
            const dataTypes = Object.keys(siteFiscalData[years[0]]);
            console.log(dataTypes);
            dataTypes.forEach(type => {
                console.log(type);
                const rowData = [type, siteFiscalData[years[0]][type].noOfPrograms, siteFiscalData[years[0]][type].noOfAttendees];

                resultArray.push(rowData);
            })
        }
        return resultArray;
    }

    const getFacilityRentals = (fiscalData) => {
        const siteFiscalData = {};
        const resultArray = [];
        fiscalData.forEach(entry => {
            const { rentals, fiscalYear } = entry;
            const totalNoOfRentals = parseInt(rentals.totalNoOfRentals) || 0;
            const totalNoOfPeople = parseInt(rentals.totalNoOfPeople) || 0;
            const totalRentalRevenue = parseFloat(rentals.totalRentalRevenue) || 0;

            if (!siteFiscalData[fiscalYear]) {
                siteFiscalData[fiscalYear] = { totalNoOfRentals: 0, totalNoOfPeople: 0, totalRentalRevenue: 0 };
            }
            siteFiscalData[fiscalYear] = {
                totalNoOfRentals: siteFiscalData[fiscalYear].totalNoOfRentals + totalNoOfRentals,
                totalNoOfPeople: siteFiscalData[fiscalYear].totalNoOfPeople + totalNoOfPeople,
                totalRentalRevenue: siteFiscalData[fiscalYear].totalRentalRevenue + totalRentalRevenue,
            };


        })
        console.log(siteFiscalData);

        const years = Object.keys(siteFiscalData).sort();
        console.log(years[0]);
        // check any records
        if (years[0]) {

            //Table Title
            const fyYears = years.map(entry => `FY${entry}/${entry % 100 + 1}`);
            resultArray.push(['Facility Rentals', ...fyYears]);

            // records
            const dataTypes = Object.keys(siteFiscalData[years[0]]);

            dataTypes.forEach(type => {
                let tempType = '';
                if (type === 'totalNoOfRentals')
                    tempType = 'Tota Rentals'
                if (type === 'totalRentalRevenue')
                    tempType = 'Rental Revenue'
                if (type === 'totalNoOfPeople')
                    tempType = 'Total Rental Attendees'
                const rowData = [tempType];
                years.forEach(year => {
                    console.log(`year:${year} && ${siteFiscalData[year][type]}`);
                    rowData.push(siteFiscalData[year][type]);
                });
                resultArray.push(rowData);
            })


        }
        return resultArray;
    }
    const annualVisitation = getTotalVisitation(visitationData);
    console.log('annualVisitation:' + annualVisitation);

    const annualVisitationFormatters = [
        {
            type: "ArrowFormat",
            column: 1,
        },
    ];

    const outOfStateVisitors = getOutofStateVisitors(visitationData);
    console.log(`outOfStateVisitors: ${outOfStateVisitors}`);
    const eventAttendance = getTotalEventAttendance(visitationData);
    console.log('eventAttendance:' + eventAttendance);

    const eventAttendanceFormatters = [
        {
            type: "ArrowFormat",
            column: 1,
        },
    ];

    const eventRevenue = getTotalEventRevenue(visitationData);
    console.log('eventRevenue:' + eventRevenue);

    const eventRevenueFormatters = [
        {
            type: "NumberFormat",
            column: 1,
            options: {
                prefix: "$"
            }
        },
    ];

    const totalAdmissionRevenue = getTotalAdmissionRevenue(visitationData);
    console.log('TotalAdmissionRevenue:' + totalAdmissionRevenue);
    const totalAdmissionRevenueFormatters = [
        {
            type: "NumberFormat",
            column: 1,
            options: {
                prefix: "$"
            }
        },

    ];
    const admissionFormatters = []
    const formattersColumns = admissionFormatters
    console.log(`count: ${totalAdmissionRevenue[0]}`)
    for (let i = 1; i < formattersColumns; i++) {
        admissionFormatters.push({
            type: "NumberFormat",
            column: 1,
            options: {
                prefix: "$"
            }
        })
    }


    const staffPerformance = getPerformanceMeasure(performanceData);
    const programOverview = getProgramOverview(performanceData);

    const facilityRentals = getFacilityRentals(fiscalData);

    const downloadCSV = () => {
        const combinedData = [
            ['Annaual Visitaion'],
            ...annualVisitation.map(row => row.join(',')),
            [''],
            ['Out of State Visitors'],
            ...outOfStateVisitors.map(row => row.join(',')),
            [''],
            ['Admissions Revenue'],
            ...totalAdmissionRevenue.map(row => row.join(',')),
            [''],
            ['Event Attendance & Revenue'],
            ...eventAttendance.map(row => row.join(',')),
            [''],
            ['Event  Revenue'],
            ...eventRevenue.map(row => row.join(',')),
            [''],
            ['Performance Measures'],
            ...staffPerformance.map(row => row.join(',')),
            [''],
            ['Programming Overview'],
            ...programOverview.map(row => row.join(',')),
            [''],
            ['Facility Rentals'],
            ...facilityRentals.map(row => row.join(',')),
            [''],
        ];

        // Convert the chart data to CSV format
        const csvContent = combinedData.join('\n');
        // Create a data URI for the CSV content
        const encodedUri = encodeURI('data:text/csv;charset=utf-8,' + csvContent);
        // Create a download link
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'SiteAnnualReport.csv');
        // Append the link to the document body and trigger the click event
        document.body.appendChild(link);
        link.click();
    };
    const createDownloadHandler = () => {
        return () => downloadCSV();
    };
    return (
        <>
            <span ><b>Site Annual Report </b> </span>
            {visitationData.length > 0 &&
                <Row className="mb-0 main-content" >
                    <Col>
                        <Button onClick={createDownloadHandler()}>Download Data</Button>
                    </Col>
                    <Col />
                    <Col />
                    <Col />
                </Row>
            }
            <Row className="mb-0 main-content" >
                <Col>
                    <Card>
                        <Card.Body>
                            <Form>
                                <Row className="mb-0 main-content" >
                                    <Form.Group as={Col} >
                                        <Form.Label>Select Site Name </Form.Label>
                                        {/* value={formData.siteName} onChange={handleInputChange} */}
                                        <Form.Select defaultValue="" name="siteName" required onChange={handleInputChange}>
                                            <option value="">Select</option>
                                            <option>ANTHRACITE HERITAGE</option>
                                            <option>BRANDYWINE BATTLEFIELD</option>
                                            <option>BUSHY </option>
                                            <option>CONRAD W</option>
                                            <option>CORNWALL</option>
                                            <option>DANIEL B</option>
                                            <option>DRAKE WELL</option>
                                            <option>ECKLEY MINERS' VLGE</option>
                                            <option>EPHRATA CLOISTER</option>
                                            <option>ERIE MARITIME</option>
                                            <option>FORT PITT</option>
                                            <option>GRAEME </option>
                                            <option>HOPE</option>
                                            <option>JOSEPH P</option>
                                            <option>LANDIS VALLEY</option>
                                            <option>OLD ECONOMY</option>
                                            <option>PENNSBURY</option>
                                            <option>PA LUMBER MUSEUM</option>
                                            <option>PA MILITARY MUSEUM</option>
                                            <option>RAILROAD MUSEUM</option>
                                            <option>SOMERSET</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formYear">

                                    </Form.Group>
                                    <Col />
                                </Row>
                            </Form>

                        </Card.Body>


                    </Card>
                </Col>

            </Row>
            {visitationData[0] ? <>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Annaual Visitaion </Card.Title>
                            <Card.Body>

                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={annualVisitation}
                                    formatters={annualVisitationFormatters}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Out of State Visitors </Card.Title>
                            <Card.Body>

                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={outOfStateVisitors}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Admissions Revenue</Card.Title>
                            <Card.Body>
                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={totalAdmissionRevenue}
                                    formatters={totalAdmissionRevenueFormatters}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Event Attendance & Revenue </Card.Title>
                            <Card.Body>
                                <Row className="mb-0 main-content" >
                                    <Col>
                                        <Card>
                                            <Card.Title>Event Attendance  </Card.Title>
                                            <Card.Body>

                                                <Chart
                                                    width={'100%'}
                                                    height={'100%'}
                                                    chartType="Table"
                                                    loader={<div>Loading Chart</div>}
                                                    data={eventAttendance}
                                                    formatters={eventAttendanceFormatters}
                                                />

                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col>
                                        <Card>
                                            <Card.Title>Event  Revenue </Card.Title>
                                            <Card.Body>

                                                <Chart
                                                    width={'100%'}
                                                    height={'100%'}
                                                    chartType="Table"
                                                    loader={<div>Loading Chart</div>}
                                                    data={eventRevenue}
                                                    formatters={eventRevenueFormatters}
                                                />

                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Performance Measures</Card.Title>
                            <Card.Body>
                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={staffPerformance}

                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Programming Overview</Card.Title>
                            <Card.Body>
                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={programOverview}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Facility Rentals</Card.Title>
                            <Card.Body>
                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={facilityRentals}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </> : <Row className="mb-0 main-content" >No data found!</Row>}
        </>
    );
}